import { URLS } from 'configs';

export const detectBrowser = () => {
  let { userAgent, vendor } = window.navigator;
  let browser = 'other';

  if (typeof InstallTrigger !== 'undefined') {
    browser = 'firefox';
  } else if (/Opera|OPR\//.test(navigator.userAgent)) {
    browser = 'opera';
  } else if (/Edg/.test(userAgent)) {
    browser = 'edge';
  } else if (/Chrome/.test(userAgent) && /Google Inc/.test(vendor) && !/Edg/.test(userAgent)) {
    browser = 'chrome';
  } else if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
    browser = 'safari';
  }

  return browser;
};

export const openExtensionUrl = () => {
  const { CHROME_EXTENSION, FIREFOX_EXTENSION, SAFARI_EXTENSION } = URLS;
  const browser = detectBrowser();
  const isFirfox = browser === 'firefox';
  const isSafari = browser === 'safari';

  if (isFirfox) {
    window.open(FIREFOX_EXTENSION, '_blank');
    return;
  }

  if (isSafari) {
    window.open(SAFARI_EXTENSION, '_blank');
    return;
  }

  window.open(CHROME_EXTENSION, '_blank');
};
